/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkContainer } from '../models/work-container';
import { WorkCreateContainerDto } from '../models/work-create-container-dto';

@Injectable({ providedIn: 'root' })
export class WorkContainersV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `containersV2ControllerFindAllByContactId()` */
  static readonly ContainersV2ControllerFindAllByContactIdPath = '/v2/containers/byContactId/{contactId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containersV2ControllerFindAllByContactId()` instead.
   *
   * This method doesn't expect any request body.
   */
  containersV2ControllerFindAllByContactId$Response(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkContainer>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainersV2Service.ContainersV2ControllerFindAllByContactIdPath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkContainer>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containersV2ControllerFindAllByContactId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  containersV2ControllerFindAllByContactId(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkContainer>> {
    return this.containersV2ControllerFindAllByContactId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkContainer>>): Array<WorkContainer> => r.body)
    );
  }

  /** Path part for operation `containersV2ControllerCreate()` */
  static readonly ContainersV2ControllerCreatePath = '/v2/containers';

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `containersV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  containersV2ControllerCreate$Response(
    params: {
      body: WorkCreateContainerDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContainer>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContainersV2Service.ContainersV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContainer>;
      })
    );
  }

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `containersV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  containersV2ControllerCreate(
    params: {
      body: WorkCreateContainerDto
    },
    context?: HttpContext
  ): Observable<WorkContainer> {
    return this.containersV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContainer>): WorkContainer => r.body)
    );
  }

}
